// extracted by mini-css-extract-plugin
export default {"dockTab":"chatbotWidget_dockTab__-EIwh","collapsed":"chatbotWidget_collapsed__HCGt2"};